import billingsCargoOrderListingFactory from "../../common/billings-cargo-order-listing.factory";

const billingsCargoOrderListingByCargoFactory = {
  createListingItems: billingsCargoOrderListingFactory.createListingItems,
};

export default billingsCargoOrderListingByCargoFactory;
